<template>
  <div>
    <svg
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      style="overflow: hidden"
      :width="svgDimensions.width"
      :height="svgDimensions.height"
      :viewBox="svgDimensions.viewBox"
      version="1.1"
      id="svg166"
      sodipodi:docname="cancha-golstats-2.svg"
      inkscape:version="0.92.3 (2405546, 2018-03-11)"
    >
      <metadata id="metadata170">
        <Rdf:RDF>
          <Cc:Work rdf:about>
            <Dc:Format>image/svg+xml</Dc:Format>
            <Dc:Type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          </Cc:Work>
        </Rdf:RDF>
      </metadata>
      <Sodipodi:Namedview
        pagecolor="#ffffff"
        borderColor="#666666"
        borderopacity="1"
        objecttolerance="10"
        gridtolerance="10"
        guidetolerance="10"
        inkscape:pageopacity="0"
        inkscape:pageshadow="2"
        inkscape:window-width="1920"
        inkscape:window-height="1017"
        id="namedview168"
        showgrid="false"
        inkscape:zoom="2.4773607"
        inkscape:cx="150"
        inkscape:cy="168.52067"
        inkscape:window-x="1432"
        inkscape:window-y="-8"
        inkscape:window-maximized="1"
        inkscape:current-layer="svg166"
      />
      <defs id="defs20">
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#808080" />
        </marker>
        <pattern id="maByRegionFieldBackground" width="1" height="1" viewBox="0 0 100 100" preserveAspectRatio="none">
          <image
            xlink:href="https://golstatsimages.blob.core.windows.net/todoelfut/fieldbg.png"
            width="100"
            height="100"
            preserveAspectRatio="none"
            id="image2"
          />
        </pattern>
        <filter id="maByRegionDropShadow" x="0" y="0" width="120%" height="120%">
          <feOffset result="offOut" in="SourceAlpha" dx="5" dy="5" id="feOffset5" />
          <feGaussianBlur result="blurOut" in="offOut" stdDeviation="3" id="feGaussianBlur7" />
          <feComponentTransfer id="feComponentTransfer11">
            <feFuncA type="linear" slope="0.5" id="feFuncA9" />
          </feComponentTransfer>
          <feMerge id="feMerge17">
            <feMergeNode id="feMergeNode13" />
            <feMergeNode in="SourceGraphic" id="feMergeNode15" />
          </feMerge>
        </filter>
      </defs>
      <g class="maByRegionChartFieldBackground" id="g24" transform="translate(25.0001)">
        <path d="M 0,0 H 165.75 V 195 H 0 Z" id="path22" inkscape:connector-curvature="0" />
      </g>
      <g class="maByRegionChartFieldLines" id="g52" transform="translate(25.0001)">
        <path d="M 0,0 H 165.75 V 195 H 0 Z" id="path26" inkscape:connector-curvature="0" />
        <path d="M 0,97.5 H 165.75" id="path28" inkscape:connector-curvature="0" />
        <path d="m 39.98,0 v 35.1 h 85.8 V 0 Z" id="path30" inkscape:connector-curvature="0" />
        <path d="m 63.38,0 v 11.7 h 39 V 0 Z" id="path32" inkscape:connector-curvature="0" />
        <path d="m 39.98,195 v -35.1 h 85.8 V 195 Z" id="path34" inkscape:connector-curvature="0" />
        <path d="m 63.38,195 v -11.7 h 39 V 195 Z" id="path36" inkscape:connector-curvature="0" />
        <circle cx="82.879997" cy="97.5" r="19.5" id="circle38" />
        <path d="m 67.28,35.1 a 19.5,19.5 0 0 0 31.2,0" id="path40" inkscape:connector-curvature="0" />
        <path d="m 98.48,159.9 a 19.5,19.5 0 0 0 -31.2,0" id="path42" inkscape:connector-curvature="0" />
        <path d="M 0,1.95 A 1.95,1.95 0 0 0 1.95,0" id="path44" inkscape:connector-curvature="0" />
        <path d="m 163.8,0 a 1.95,1.95 0 0 0 1.95,1.95" id="path46" inkscape:connector-curvature="0" />
        <path d="M 1.95,195 A 1.95,1.95 0 0 0 0,193.05" id="path48" inkscape:connector-curvature="0" />
        <path d="M 165.75,193.05 A 1.95,1.95 0 0 0 163.8,195" id="path50" inkscape:connector-curvature="0" />
      </g>
      {{ `n${+Math.floor((dataProccesed[0][0] * 100) / max / 10).toFixed(2)}` }}
      <g id="row-0">
        <g
          id="col-0-0"
          :class="[dataProccesed[0][0] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(1, dataProccesed[0][0])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[0][0] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="0"
            y="0"
            width="40"
            height="48.75"
            id="rect126"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[0][0] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="20"
            y="24.375"
            id="text128"
          >
            {{ dataProccesed[0][0] }}
          </text>
        </g>
        <g
          id="col-0-1"
          :class="[dataProccesed[0][1] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(2, dataProccesed[0][1])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[0][1] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="40"
            y="0"
            width="43"
            height="48.75"
            id="rect132"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[0][1] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="61.5"
            y="24.375"
            id="text134"
          >
            {{ dataProccesed[0][1] }}
          </text>
        </g>
        <g
          id="col-0-2"
          :class="[dataProccesed[0][2] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(3, dataProccesed[0][2])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[0][2] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="83"
            y="0"
            width="43"
            height="48.75"
            id="rect138"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[0][2] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="104.5"
            y="24.375"
            id="text140"
          >
            {{ dataProccesed[0][2] }}
          </text>
        </g>
        <g
          id="col-0-3"
          :class="[dataProccesed[0][3] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(4, dataProccesed[0][3])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[0][3] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="126"
            y="0"
            width="40"
            height="48.75"
            id="rect144"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[0][3] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="146"
            y="24.375"
            id="text146"
          >
            {{ dataProccesed[0][3] }}
          </text>
        </g>
      </g>
      <g id="row-1">
        <g
          id="col-1-0"
          :class="[dataProccesed[1][0] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(5, dataProccesed[1][0])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[1][0] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="0"
            y="48.75"
            width="40"
            height="48.75"
            id="rect102"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[1][0] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="20"
            y="73.125"
            id="text104"
          >
            {{ dataProccesed[1][0] }}
          </text>
        </g>
        <g
          id="col-1-1"
          :class="[dataProccesed[1][1] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(6, dataProccesed[1][1])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[1][1] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="40"
            y="48.75"
            width="43"
            height="48.75"
            id="rect108"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[1][1] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="61.5"
            y="73.125"
            id="text110"
          >
            {{ dataProccesed[1][1] }}
          </text>
        </g>
        <g
          id="col-1-2"
          :class="[dataProccesed[1][2] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(7, dataProccesed[1][2])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[1][2] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="83"
            y="48.75"
            width="43"
            height="48.75"
            id="rect114"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[1][2] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="104.5"
            y="73.125"
            id="text116"
          >
            {{ dataProccesed[1][2] }}
          </text>
        </g>
        <g
          id="col-1-3"
          :class="[dataProccesed[1][3] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(8, dataProccesed[1][3])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[1][3] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="126"
            y="48.75"
            width="40"
            height="48.75"
            id="rect120"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[1][3] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="146"
            y="73.125"
            id="text122"
          >
            {{ dataProccesed[1][3] }}
          </text>
        </g>
      </g>
      <g id="row-2">
        <g
          id="col-2-0"
          :class="[dataProccesed[2][0] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(9, dataProccesed[2][0])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[2][0] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="0"
            y="97.5"
            width="40"
            height="48.75"
            id="rect78"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[2][0] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="20"
            y="121.875"
            id="text80"
          >
            {{ dataProccesed[2][0] }}
          </text>
        </g>
        <g
          id="col-2-1"
          :class="[dataProccesed[2][1] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(10, dataProccesed[2][1])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[2][1] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="40"
            y="97.5"
            width="43"
            height="48.75"
            id="rect84"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[2][1] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="61.5"
            y="121.875"
            id="text86"
          >
            {{ dataProccesed[2][1] }}
          </text>
        </g>
        <g
          id="col-2-2"
          :class="[dataProccesed[2][2] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(11, dataProccesed[2][2])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[2][2] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="83"
            y="97.5"
            width="43"
            height="48.75"
            id="rect90"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[2][2] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="104.5"
            y="121.875"
            id="text92"
          >
            {{ dataProccesed[2][2] }}
          </text>
        </g>
        <g
          id="col-2-3"
          :class="[dataProccesed[2][3] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(12, dataProccesed[2][3])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[2][3] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="126"
            y="97.5"
            width="40"
            height="48.75"
            id="rect96"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[2][3] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="146"
            y="121.875"
            id="text98"
          >
            {{ dataProccesed[2][3] }}
          </text>
        </g>
      </g>
      <g id="row-3">
        <g
          id="col-3-0"
          :class="[dataProccesed[3][0] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(13, dataProccesed[3][0])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[3][0] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="0"
            y="146.25"
            width="40"
            height="48.75"
            id="rect54"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[3][0] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="20"
            y="170.625"
            id="text56"
          >
            {{ dataProccesed[3][0] }}
          </text>
        </g>
        <g
          id="col-3-1"
          :class="[dataProccesed[3][1] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(14, dataProccesed[3][1])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[3][1] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="40"
            y="146.25"
            width="43"
            height="48.75"
            id="rect60"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[3][1] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="61.5"
            y="170.625"
            id="text62"
          >
            {{ dataProccesed[3][1] }}
          </text>
        </g>
        <g
          id="col-3-2"
          :class="[dataProccesed[3][2] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(15, dataProccesed[3][2])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[3][2] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="83"
            y="146.25"
            width="43"
            height="48.75"
            id="rect66"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[3][2] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="104.5"
            y="170.625"
            id="text68"
          >
            {{ dataProccesed[3][2] }}
          </text>
        </g>
        <g
          id="col-3-3"
          :class="[dataProccesed[3][3] > 0 ? 'section-field' : '']"
          transform="translate(25.0001)"
          @click="setOpenMedia(16, dataProccesed[3][3])"
        >
          <rect
            :class="[
              'maRegionTier',
              negative ? 'negative' : 'positive',
              `n${+Math.floor((dataProccesed[3][3] * 100) / max / 10).toFixed(2)}`,
            ]"
            x="126"
            y="146.25"
            width="40"
            height="48.75"
            id="rect72"
          />
          <text
            class="maRegionPercentageText"
            :class="[isMobile && dataProccesed[3][3] > 0 ? 'maRegionPercentageTextUnder' : '']"
            x="146"
            y="170.625"
            id="text74"
          >
            {{ +dataProccesed[3][3].toFixed(2) }}
          </text>
        </g>
      </g>
      <g id="vertical-sums">
        <text class="maTotalPercentageText" :x="isMinMobile ? 10.0001693 : 5" y="24.375" id="sum-row-0">
          {{ +(dataProccesed[0][0] + dataProccesed[0][1] + dataProccesed[0][2] + dataProccesed[0][3]).toFixed(2) }}
        </text>
        <text class="maTotalPercentageText" :x="isMinMobile ? 10.0001693 : 5" y="73.125" id="sum-row-1">
          {{ +(dataProccesed[1][0] + dataProccesed[1][1] + dataProccesed[1][2] + dataProccesed[1][3]).toFixed(2) }}
        </text>
        <text class="maTotalPercentageText" :x="isMinMobile ? 10.0001693 : 5" y="121.875" id="sum-row-2">
          {{ +(dataProccesed[2][0] + dataProccesed[2][1] + dataProccesed[2][2] + dataProccesed[2][3]).toFixed(2) }}
        </text>
        <text class="maTotalPercentageText" :x="isMinMobile ? 10.0001693 : 5" y="170.625" id="sum-row-3">
          {{ +(dataProccesed[3][0] + dataProccesed[3][1] + dataProccesed[3][2] + dataProccesed[3][3]).toFixed(2) }}
        </text>
      </g>
      <g id="horizontal-sums" transform="translate(8)">
        <text class="maTotalPercentageText" x="37.333332" y="212" id="sum-col-0">
          {{ +(dataProccesed[3][0] + dataProccesed[2][0] + dataProccesed[1][0] + dataProccesed[0][0]).toFixed(2) }}
        </text>
        <text class="maTotalPercentageText" x="78.583359" y="212" id="sum-col-1">
          {{ +(dataProccesed[3][1] + dataProccesed[2][1] + dataProccesed[1][1] + dataProccesed[0][1]).toFixed(2) }}
        </text>
        <text class="maTotalPercentageText" x="121.08336" y="212" id="sum-col-2">
          {{ +(dataProccesed[3][2] + dataProccesed[2][2] + dataProccesed[1][2] + dataProccesed[0][2]).toFixed(2) }}
        </text>
        <text class="maTotalPercentageText" x="162.33327" y="212" id="sum-col-3">
          {{ +(dataProccesed[3][3] + dataProccesed[2][3] + dataProccesed[1][3] + dataProccesed[0][3]).toFixed(2) }}
        </text>
      </g>
      <g id="direction" transform="translate(8)">
        <line x1="194" y1="140" x2="194" y2="60" stroke="#808080" stroke-width="2" marker-end="url(#arrowhead)" />
      </g>
    </svg>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { fieldSectorsFromSectionsIndex } from '@/data/meda-player/advanced-filter-soccer-field';

export default {
  name: 'StatisticField',
  props: {
    data: {
      type: Array,
      required: false,
      default: function() {
        return [];
      },
    },
    negative: {
      type: Boolean,
      required: false,
      default: false,
    },
    categoryIds: {
      type: Array,
      default: () => [],
    },
    coordinatePoint: {
      type: Number,
      default: 0,
    },
    generalName: {
      type: String,
      default: '',
    },
    singleName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
      seasonSelected: 'getSeasonId',
    }),
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapGetters('playersGeneral', {
      playerId: 'playerId',
    }),
    ...mapState(['windowWidth']),
    ...mapState('filterGeneral', ['tournamentsForMediaPlayer']),
    max() {
      return Math.max(...[].concat(...this.dataProccesed));
    },
    dataProccesed() {
      return this.data.map(da => da.map(d => +(d / this.gamesPlayed).toFixed(2)));
    },
    gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
    isMinMobile() {
      return this.windowWidth < 375;
    },
    isMobile() {
      return this.$mq === 'mobile';
    },
    svgDimensions() {
      const width = this.isMinMobile ? 250 : 310;
      const height = width * 0.9701;
      return {
        width,
        height,
        viewBox: `0 0 ${220} ${250}`,
      };
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    setOpenMedia(sector, value) {
      if (value > 0) {
        let jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds: this.categoryIds,
          categorySingleName: this.singleName,
          mainSectionType: 1,
          gameIds: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: {},
          advancedFilter: {
            playListTitle: this.generalName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: this.getSections,
            fieldSections: [fieldSectorsFromSectionsIndex[sector]],
            coordinatePoint: this.coordinatePoint,
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
          jsonConfig.playListType = 3;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.playListType = 2;
          jsonConfig.teamId = 0;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
  },
};
</script>

<style scoped>
.section-field:hover .maRegionTier {
  fill: rgb(51, 170, 221) !important;
  stroke: rgb(51, 170, 221) !important;
  fill-opacity: 0.9 !important;
  cursor: pointer;
  text-decoration: underline;
}

.section-field:hover .maRegionPercentageText {
  cursor: pointer;
  text-decoration: underline;
}
@media screen and (max-width: 768px) {
  .maRegionPercentageTextUnder {
    text-decoration: underline;
  }
}
.maByRegionChartFieldLines {
  stroke: #ddd;
  stroke-width: 0.75;
  fill: none;
}

.maByRegionChartFieldBackground {
  fill: url(#maByRegionFieldBackground);
  filter: url(#maByRegionDropShadow);
}

.maRegionTier {
  stroke: #ffffff;
  stroke-width: 0.5;
  stroke-opacity: 0.7;
}
/* .maRegionTier:hover {
  fill: rgb(51, 170, 221) !important;
  stroke: rgb(51, 170, 221) !important;
  fill-opacity: 1 !important;
  stroke-width: 0.5;
  stroke-opacity: 0.7;
  cursor: pointer;
} */

.positive.n10 {
  fill: rgb(90, 255, 68);
  fill-opacity: 0.7;
}
.positive.n9 {
  fill: rgb(99, 255, 85);
  fill-opacity: 0.7;
}
.positive.n9:hover {
  background: red;
}
.positive.n8 {
  fill: rgb(120, 255, 102);
  fill-opacity: 0.7;
}
.positive.n7 {
  fill: rgb(146, 255, 119);
  fill-opacity: 0.6;
}
.positive.n6 {
  fill: rgb(160, 255, 136);
  fill-opacity: 0.6;
}
.positive.n5 {
  fill: rgb(162, 255, 153);
  fill-opacity: 0.5;
}
.positive.n4 {
  fill: rgb(170, 255, 170);
  fill-opacity: 0.5;
}
.positive.n3 {
  fill: rgb(170, 255, 174);
  fill-opacity: 0.4;
}
.positive.n2 {
  fill: rgb(180, 255, 170);
  fill-opacity: 0.35;
}
.positive.n1 {
  fill: rgb(170, 255, 184);
  fill-opacity: 0.3;
}
.positive.n0 {
  fill: rgb(170, 255, 191);
  fill-opacity: 0.2;
}

.positive.nNaN {
  fill: rgb(170, 255, 191);
  fill-opacity: 0;
}

.negative.nNaN {
  fill: rgb(255, 68, 68);
  fill-opacity: 0;
}

.negative.n10 {
  fill: rgb(255, 68, 68);
  fill-opacity: 0.7;
}
.negative.n9 {
  fill: rgb(255, 85, 85);
  fill-opacity: 0.7;
}
.negative.n8 {
  fill: rgb(255, 102, 102);
  fill-opacity: 0.7;
}
.negative.n7 {
  fill: rgb(255, 119, 119);
  fill-opacity: 0.6;
}
.negative.n6 {
  fill: rgb(255, 136, 136);
  fill-opacity: 0.6;
}
.negative.n5 {
  fill: rgb(255, 153, 153);
  fill-opacity: 0.5;
}
.negative.n4 {
  fill: rgb(255, 170, 170);
  fill-opacity: 0.5;
}
.negative.n3 {
  fill: rgb(255, 170, 170);
  fill-opacity: 0.4;
}
.negative.n2 {
  fill: rgb(255, 170, 170);
  fill-opacity: 0.35;
}
.negative.n1 {
  fill: rgb(255, 170, 170);
  fill-opacity: 0.3;
}
.negative.n0 {
  fill: rgb(255, 170, 170);
  fill-opacity: 0.2;
}

.maRegionPercentageText,
.maRegionCountText {
  font-size: 14px;
  text-anchor: middle;
}

.maTotalPercentageText {
  fill: #808080;
  font-size: 10px;
  text-anchor: middle;
}

.maRegionPercentageText {
  fill: #fff;
  font-size: 11px;
}

.maRegionCountText {
  font-size: 9px;
  fill: #eee;
}
</style>
